import type { Me } from "../api/types";

interface AppHeaderProps {
  me: Me | null;
  onHome(): void;
  onSignIn(): void;
  onSignOut(): void;
  onProfile(): void;
  onHistory(): void;
  compact?: boolean;
}

/** Shared top bar for the calendar, race, profile, and history screens. */
export function AppHeader({
  me,
  onHome,
  onSignIn,
  onSignOut,
  onProfile,
  onHistory,
  compact = false,
}: AppHeaderProps) {
  return (
    <header className={`app-header ${compact ? "app-header--compact" : ""}`}>
      <button type="button" className="app-header__brand" onClick={onHome}>
        <span className="wordmark wordmark--small">
          <span className="wordmark__mark" />
          <span>CIMARA</span>
        </span>
      </button>

      <nav className="app-header__nav" aria-label="Main">
        <button type="button" className="app-header__link" onClick={onHome}>
          Calendar
        </button>
        {me ? (
          <button type="button" className="app-header__link" onClick={onHistory}>
            History
          </button>
        ) : null}
        {me ? (
          <button type="button" className="app-header__link" onClick={onProfile}>
            Profile
          </button>
        ) : null}
      </nav>

      <div className="app-header__account">
        {me ? (
          <>
            <span className="app-header__user" title={me.user.email ?? undefined}>
              <span className="app-header__avatar">
                {(me.profile?.displayName ?? me.user.name ?? "R").slice(0, 1).toUpperCase()}
              </span>
              <span className="app-header__name">
                {me.profile?.displayName ?? me.user.name ?? "Rider"}
              </span>
              <span className="app-header__category">Cat {me.category}</span>
            </span>
            <button type="button" className="app-header__link" onClick={onSignOut}>
              Sign out
            </button>
          </>
        ) : (
          <button
            type="button"
            className="app-header__signin"
            data-testid="sign-in"
            onClick={onSignIn}
          >
            Sign in
          </button>
        )}
      </div>
    </header>
  );
}
